import { useTranslation } from 'react-i18next'

export const useDeliveryMethod = () => {
  const { t } = useTranslation()

  const deliveryMethod: Record<string, string> = {
    normal: t('deliveryMethod.normal'),
    large: t('deliveryMethod.large'),
    frozen: t('deliveryMethod.frozen'),
  }

  const getI18nDeliveryMethod = (delivery: string) => {
    return deliveryMethod[delivery] || ''
  }

  return { getI18nDeliveryMethod }
}
